export default __webpack_public_path__ + "static/media/SAL1.15f09257.jpg";